import gsap from 'gsap';
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

(() => {

  const parent = document.getElementById('uptake-statistics');
  const counters = document.querySelectorAll('[data-counter]');

  if (!parent || !counters) { return; }

  gsap.utils.toArray(counters).forEach(item => {

    let content = item.textContent;
    let delimiter = (content.includes('.') ? '.' : ' ');
    let number = content.replaceAll(delimiter, '').replace(/\s/g, '');
    let start = parseInt(number - 1000);
    let increment = 1;

    gsap.fromTo(item, {
      textContent: start
    }, {
      duration: 1,
      ease: "power4.out",
      textContent: number,
      modifiers: {
        textContent: function(textContent) {
          return gsap.utils
            .snap(increment, textContent)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, delimiter);
        }
      },
      scrollTrigger: {
        trigger: parent,
        start: 'top center'
      }
    });
  });
})()
